import { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { styled } from 'styled-components';
import PageLayout from '@/components/page-layout';
import DashboardCard from '@/routes/dashboard/components/dashboard-card';
import { fetchMetrics } from '@/routes/dashboard/redux/actions';
import { useURLState } from '@/hooks';
import { useDashboardSelector } from '@/routes/dashboard/redux/reducer';
import DatePeriodPicker from '@/components/date-period-picker';

export const Dashboard: FC = () => {
	const { metrics, range, compare } = useDashboardSelector((state) => ({
		metrics: state.metrics,
		range: state.range,
		compare: state.compare
	}));

	const dispatch = useDispatch();
	const { urlState } = useURLState();

	useEffect(() => {
		const { rangeFrom, rangeTo, compareFrom, compareTo } = urlState;
		if (rangeFrom && rangeTo && compareFrom && compareTo) {
			dispatch(fetchMetrics(urlState));
		}
	}, [urlState, dispatch]);

	return (
		<PageLayout>
			<PageActions>
				<DatePeriodPicker range={range} compare={compare} />
			</PageActions>

			<CardsContainer>
				{metrics.map((card: any, index: any) => (
					<DashboardCard key={index} {...card} />
				))}
			</CardsContainer>
		</PageLayout>
	);
};

const CardsContainer = styled.div`
	display: grid;
	gap: 2rem;
	grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
`;

const PageActions = styled.div`
	margin-bottom: 30px;
`;
